import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("Verificando...");
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const hasVerified = useRef(false);

  useEffect(() => {
    const verify = async () => {
      // Evitar múltiples llamadas usando useRef
      if (!token || hasVerified.current) return;
      
      hasVerified.current = true;
      
      try {
        console.log("🔄 Iniciando verificación de email...");
        const res = await axios.get(`/api/auth/verify-email?token=${token}`);
        console.log("✅ Verificación exitosa:", res.data);
        setMessage(res.data.message || "Cuenta verificada con éxito 🎉");
        
        // Redirigir después de 3 segundos
        setTimeout(() => {
          navigate("/login");
        }, 3000);
        
      } catch (err) {
        console.error("❌ Error en verificación:", err.response?.data);
        setMessage(err.response?.data?.detail || "Token inválido o expirado ❌");
      }
    };
    
    verify();
  }, [token, navigate]);

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="bg-white p-6 rounded-lg shadow-md w-96 text-center">
        <h2 className="text-xl font-bold mb-4">Verificación de correo</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default VerifyEmailPage;